import colors from 'vuetify/es5/util/colors';

import moment from 'moment';

export const PersonListItemWithAvatarMixin = {
  methods: {
    DateOfBirthFormatChecker() {
      if (this.child.age) {
        return moment().diff(this.child.age, 'years');
      } else if (this.child.dob) {
        return moment().diff(this.child.dob, 'years');
      }
    },
    viewToChildPage() {
      this.$router.push(
        `${this.viewToChildPageRoute2}/child/${this.child.personId}`
      );
    }
  },
  computed: {
    childDobString() {
      let yearDifference = this.DateOfBirthFormatChecker();

      if (yearDifference < 1) {
        let monthDifference = moment().diff(this.child.age, 'months');

        let monthString;

        if (monthDifference == 1) {
          monthString = 'month';
        } else {
          monthString = 'months';
        }

        return `${monthDifference} ${monthString} old,`;
      } else {
        let yearString;
        if (yearDifference == 1) {
          yearString = 'year';
        } else {
          yearString = 'years';
        }

        return `${yearDifference} ${yearString} old`;
      }
    },

    childGenderString() {
      if (this.child.gender == 'm') {
        return 'boy';
      } else if (this.child.gender == 'f') {
        return 'girl';
      }
      return '';
    },

    childInitials() {
      let firstNameFirstInitial = this.childFirstName[0].toUpperCase();
      let lastNameFirstInitial = this.childLastName[0].toUpperCase();

      return firstNameFirstInitial + lastNameFirstInitial;
    },

    childFullName() {
      return `${this.childFirstName} ${this.childLastName}`;
    },

    childVitalDetails() {
      return `${this.childDobString}`;
    },

    childFirstName() {
      if (this.child.firstName) {
        return this.child.firstName;
      } else {
        return 'First Name';
      }
    },
    childLastName() {
      if (this.child.lastName) {
        return this.child.lastName;
      } else {
        return 'Last Name';
      }
    },
    colours() {
      let colours = [];
      for (const color in colors) {
        if (color !== 'shades') {
          colours.push(
            color.replace(/([a-zA-Z])(?=[A-Z])/g, '$1-').toLowerCase()
          );
        }
      }
      colours.push(
        'red',
        'green',
        'blue',
        'purple',
        'yellow',
        'teal',
        'red',
        'green'
      );
      return colours;
    },

    randomNumberBasedOnInitials() {
      const alphabet = [...'abcdefghijklmnopqrstuvwxyz'];
      const firstNameFirstInitial = this.childFirstName[0];
      const index = alphabet.indexOf(firstNameFirstInitial.toLowerCase());

      return index < 0 ? Math.floor(Math.random * 26) + 1 : index;
    },

    randomColour() {
      return this.colours[this.randomNumberBasedOnInitials];
    },

    randomColourText() {
      return `${this.randomColour}--text`;
    },

    avatarBackgroundColour() {
      if (this.child.firstName && this.childFirstName.length > 0) {
        const alphabet = [...'abcdefghijklmnopqrstuvwxyz'];
        let firstNameFirstInitial = this.childFirstName[0];
        let index = alphabet.indexOf(firstNameFirstInitial.toLowerCase());
        if (index > 13) {
          return 'light-green';
        } else {
          return 'teal darken-1';
        }
      } else {
        return 'light-orange';
      }
    },
    parentDetails() {
    //  debugger;
      return `${this.parent.firstName} ${this.parent.lastName}`;
    },

    viewContactRoute() {
      return `/cms/contacts/view`;
    },
    viewChildContactRoute() {
      return `${this.viewContactRoute}/${this.child.personId}`;
    },
    viewParentContactRoute() {
      return `${this.viewContactRoute}/${this.parent.personId}`;
    },
    viewToChildPageRoute() {
      return `/#/profile`;
    },
    viewToChildPageRoute2() {
      return `/profile`;
    }
  },

  components: {},
  props: {
    child: {
      type: Object,
      required: true
    },
    parent: {
      type: Object,
      required: false,
      default() {
        if (this.child.parent) {
          return this.child.parent;
        }
      }
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  updated() {}
};
